let sent = 0;

/** Sends unexpected front-end errors to the server log (Workers Logs). At most 10 per page load. */
export function reportClientError(error: unknown, context?: string): void {
  if (sent >= 10) return;
  sent++;
  const err = error instanceof Error ? error : new Error(String(error));
  const body = JSON.stringify({
    message: err.message.slice(0, 2000),
    stack: err.stack?.slice(0, 8000),
    url: location.pathname.slice(0, 500),
    context: context?.slice(0, 500),
  });
  try {
    void fetch('/api/v1/client-errors', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body, keepalive: true, credentials: 'same-origin' });
  } catch {
    // ignore
  }
}

export function installGlobalErrorReporting(): void {
  window.addEventListener('error', (e) => reportClientError(e.error ?? e.message, 'window.error'));
  window.addEventListener('unhandledrejection', (e) => reportClientError(e.reason, 'unhandledrejection'));
}
